import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchKuyaJProducts } from "@/app/_lib/data/productQueries";

export const runProductSearch = createAsyncThunk(
  "search/run",
  async ({
    branchId,
    category = "all",
    q = "",
    order = "selling_price.desc",
  }) => {
    const res = await fetchKuyaJProducts({ branchId, category, q, order });
    return { q, items: res.data ?? [] };
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState: { q: "", items: [], loading: false, error: null },
  reducers: {
    setQ(state, { payload }) {
      state.q = payload ?? "";
      if (!state.q) {
        state.items = []; // optional: clear items when query cleared
      }
    },
    clear(state) {
      state.q = "";
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(runProductSearch.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(runProductSearch.fulfilled, (s, { payload }) => {
      s.q = payload.q;
      s.items = payload.items;
      s.loading = false;
    });
    b.addCase(runProductSearch.rejected, (s, a) => {
      s.loading = false;
      s.error = a.error?.message || "Search failed";
    });
  },
});

export const { setQ, clear } = searchSlice.actions;
export const selectSearchQ = (s) => s.search.q;
export const selectSearchItems = (s) => s.search.items;
export const selectSearchLoading = (s) => s.search.loading;
export const selectSearchError = (s) => s.search.error;

export default searchSlice.reducer;
